import axios from 'axios'
import config from '@/config'

const actions = {
  SAVE_OCCUPANT({rootGetters}, community) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'occupant/save', community, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  ADD_OCCUPANT({rootGetters}, request) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'occupant/add', request, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err.response.data))
    })
  },
  DELETE_OCCUPANT({rootGetters}, occupantId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.APi_URL + 'occupant/delete/' + occupantId, rootGetters.getRequestConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  GET_OCCUPANT_DETAILS({rootGetters}, occupantId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'occupant/' + occupantId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_OCCUPANT_DETAILS_BY_PASSPORT({rootGetters}, passport) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + `occupant/${passport}/details`, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
